export default function(input) {
    var map = {
        'EllipseAdmin': 0, 
        'EllipseTech': 10, 
        'CreditDistributor': 20,
    }

    if( typeof input === 'string' ){
        return map[input];
    }else{
        if( input === 0 )
            return 'EllipseAdmin'
        else if( input === 10 )
            return 'EllipseTech'
        else if( input === 20 )
            return 'CreditDistributor'
        else   
            return undefined;
    }
}


// WEBPACK FOOTER //
// ./WebApp/utils/roles.js